export const getExternalId = state => state.external.id;
